module.exports = "https://www.gc-pro.gnp.com.mx/f583eb9f09fea4f856e5ea99fca3e185.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/xml_icon.svg
// module id = 1867
// module chunks = 0